export enum ListOfItemsUseCases {
  Regular = "Regular",
  Contract = "Contract",
  Foreign = "Foreign",
}
